import { css } from "styled-components";
import token from "styled-token";
import { mediaQueryMixin } from "../mediaQueryMixin";
import { inlineMediaQueryMixin } from "../inlineMediaQueryMixin";
import { typographyMixin } from "../typographyMixin";
import { spacingMixin } from "../spacingMixin";
import { StyledIcon } from "../../components/Icon/Icon";
import { StyledImage } from "../../components/Image/Image";
import getInitials from "../../util/getInitials";
import { T_SHIRT_SIZES } from "../../constants/T_SHIRT_SIZES";
var sizeCSS = inlineMediaQueryMixin("size", function (mediaProps) {
  var children = mediaProps.children,
      fullName = mediaProps.fullName,
      tshirt = mediaProps.size;
  return token({
    size: "Avatar.sizes." + tshirt,
    fontType: "Avatar.fontTypes." + tshirt
  }, function (_ref) {
    var size = _ref.size,
        fontType = _ref.fontType;
    var content;

    if (typeof children === "undefined") {
      var initials = getInitials(fullName); // One letter for xs, sm, md sizes

      if (tshirt === T_SHIRT_SIZES.xs || tshirt === T_SHIRT_SIZES.sm || tshirt === T_SHIRT_SIZES.md) {
        initials = initials.charAt(0);
      }

      content = css(["&:after{content:\"", "\";}"], initials);
    }

    return css(["height:", "px;width:", "px;", " ", " > ", "{height:", "px;width:", "px;}> ", "{height:100%;width:100%;object-fit:cover;}"], size, size, typographyMixin(Object.assign({
      fontColor: null
      /* color handled separately */
      ,
      fontType: fontType,
      fontTypeIconAlignment: false
    }, mediaProps)), content, StyledIcon, size / 2, size / 2, StyledImage);
  })(mediaProps);
});

var colorCSS = function colorCSS(props) {
  var background = props.background;
  return token({
    colors: "colors",
    iconColor: "Avatar.iconColor"
  }, function (_ref2) {
    var colors = _ref2.colors,
        iconColor = _ref2.iconColor;

    if (!colors) {
      return "";
    }

    return css(["background-color:", "};color:", ";> ", "{color:", ";}"], colors[background], background === "gray200" ? colors.textDark : colors.textWhite, StyledIcon, background === "gray200" ? iconColor : colors.textWhite);
  })(props);
};
/** @class AvatarMixin */

/** @method */


export var AvatarMixin = function AvatarMixin(props) {
  return css(["overflow:hidden;display:inline-flex;justify-content:center;align-items:center;border-radius:50%;", " ", " ", " ", ""], sizeCSS(props), mediaQueryMixin(function (mediaProps) {
    return sizeCSS(Object.assign({}, props, mediaProps));
  }), colorCSS(props), spacingMixin(props));
};